import { render, staticRenderFns } from "./AboutContent.vue?vue&type=template&id=8b5ff8c0&scoped=true&"
import script from "./AboutContent.vue?vue&type=script&lang=ts&"
export * from "./AboutContent.vue?vue&type=script&lang=ts&"
import style0 from "./AboutContent.vue?vue&type=style&index=0&id=8b5ff8c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5ff8c0",
  null
  
)

export default component.exports